window.postMessage = HandleStudio;
/*------------------ Date Function ------------------------*/
/**
 * 获取当前日期的完整格式字符串。
 * 该函数用于生成形如YYYY-MM-DD的日期字符串，确保日期的格式化输出一致。
 * 不接受任何参数。
 * 返回当前日期的字符串表示，格式为YYYY-MM-DD。
 */
function GetFullToday()
{
    // 创建一个新的Date对象，以获取当前日期和时间
    var d=new Date();

    // 获取当前日期的天数
    var nday=d.getDate();
    // 获取当前日期的月份，注意月份从0开始计算，因此需要加1
    var nmonth=d.getMonth()+1;
    // 获取当前日期的年份
    var nyear=d.getFullYear();

    // 将月份转换为字符串，如果月份小于10，则在其前添加0，以保证两位数格式
    var strM=nmonth+'';
    if( nmonth<10 )
        strM='0'+nmonth;

    // 将日期转换为字符串，如果日期小于10，则在其前添加0，以保证两位数格式
    var strD=nday+'';
    if( nday<10 )
        strD='0'+nday;

    // 返回格式化后的日期字符串，年-月-日的格式
    return nyear+'-'+strM+'-'+strD;
}


function GetFullDate()
{
    var d=new Date();

    var tDate={};

    tDate.nyear=d.getFullYear();
    tDate.nmonth=d.getMonth()+1;
    tDate.nday=d.getDate();

    tDate.nhour=d.getHours();
    tDate.nminute=d.getMinutes();
    tDate.nsecond=d.getSeconds();

    tDate.nweek=d.getDay();
    tDate.ndate=d.getDate();

    var strM=tDate.nmonth+'';
    if( tDate.nmonth<10 )
        strM='0'+tDate.nmonth;

    var strD=tDate.nday+'';
    if( tDate.nday<10 )
        strD='0'+tDate.nday;

    var strH=tDate.nhour+'';
    if( tDate.nhour<10 )
        strH='0'+tDate.nhour;

    var strMin=tDate.nminute+'';
    if( tDate.nminute<10 )
        strMin='0'+tDate.nminute;

    var strS=tDate.nsecond+'';
    if( tDate.nsecond<10 )
        strS='0'+tDate.nsecond;

    tDate.strdate=tDate.nyear+'-'+strM+'-'+strD;
    tDate.strFulldate=tDate.strdate+' '+strH+':'+strMin+':'+strS;

    return tDate;
}


/**
 * 将Unix时间戳转换为日期字符串。
 * Unix时间戳是以秒为单位自1970年1月1日00:00:00 GMT以来的总秒数。
 * 此函数将这个时间戳转换为YYYY-MM-DD的格式。
 *
 * @param {number} nSecond Unix时间戳，以秒为单位。
 * @returns {string} 转换后的日期字符串，格式为YYYY-MM-DD。
 */
function Unixtimestamp2Date( nSecond )
{
    // 创建一个Date对象，参数是时间戳乘以1000，因为JavaScript的Date对象需要的是毫秒数。
    var d=new Date(nSecond*1000);

    // 初始化一个对象，用于存储日期和时间的各个部分。
    var tDate={};

    // 获取并存储年份。
    tDate.nyear=d.getFullYear();
    // 获取并存储月份，注意JavaScript的月份是从0开始的，所以要加1。
    tDate.nmonth=d.getMonth()+1;
    // 获取并存储日。
    tDate.nday=d.getDate();

    // 获取并存储小时。
    tDate.nhour=d.getHours();
    // 获取并存储分钟。
    tDate.nminute=d.getMinutes();
    // 获取并存储秒。
    tDate.nsecond=d.getSeconds();

    // 获取并存储一周中的某一天（0表示周日，1表示周一，以此类推）。
    tDate.nweek=d.getDay();
    // 获取并存储日期，与nday相同。
    tDate.ndate=d.getDate();

    // 将月份转换为字符串，如果月份小于10，则在其前添加一个0，以保证两位数。
    var strM=tDate.nmonth+'';
    if( tDate.nmonth<10 )
        strM='0'+tDate.nmonth;

    // 将日转换为字符串，如果日小于10，则在其前添加一个0，以保证两位数。
    var strD=tDate.nday+'';
    if( tDate.nday<10 )
        strD='0'+tDate.nday;

    // 组装日期字符串，格式为YYYY-MM-DD。
    tDate.strdate=tDate.nyear+'-'+strM+'-'+strD;

    // 返回日期字符串。
    return tDate.strdate;
}



//------------Array Function-------------
Array.prototype.in_array = function (e) {
    let sArray= ',' + this.join(this.S) + ',';
    let skey=','+e+',';

    if(sArray.indexOf(skey)>=0)
        return true;
    else
        return false;
}



//------------String Function------------------
/**
 * Delete Left/Right Side Blank
 */
String.prototype.trim=function()
{
    return this.replace(/(^\s*)|(\s*$)/g, '');
}
/**
 * Delete Left Side Blank
 */
String.prototype.ltrim=function()
{
    return this.replace(/(^\s*)/g,'');
}
/**
 * Delete Right Side Blank
 */
String.prototype.rtrim=function()
{
    return this.replace(/(\s*$)/g,'');
}


//----------------Get Param-------------
function GetQueryString(name)
{
    var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if (r!=null)
    {
        return unescape(r[2]);
    }
    else
    {
        return null;
    }
}

function GetGetStr()
{
    let strGet="";

    //获取当前URL
    let url = document.location.href;

    //获取?的位置
    let index = url.indexOf("?")
    if(index != -1) {
        //截取出?后面的字符串
        strGet = url.substr(index + 1);
    }

    return strGet;
}


/*--------------------JSON  Function------------*/

/*
功能：检查一个字符串是不是标准的JSON格式
参数： strJson          被检查的字符串
返回值： 如果字符串是一个标准的JSON格式，则返回JSON对象
        如果字符串不是标准JSON格式，则返回null
*/
function IsJson( strJson )
{
    var tJson=null;
    try
    {
        tJson=JSON.parse(strJson);
    }
    catch(exception)
    {
        return null;
    }

    return tJson;
}

/*-----------------------Ajax Function--------------------*/
/*对JQuery的Ajax函数的封装，只支持异步
参数说明：
    url      目标地址
	action   post/get
	data     字符串格式的发送内容
	asyn     true---异步模式;false-----同步模式;
*/
function HttpReq( url,action, data,callbackfunc)
{
    var strAction=action.toLowerCase();

    if( strAction=="post")
    {
        $.post(url,data,callbackfunc);
    }
    else if( strAction=="get")
    {
        $.get(url,callbackfunc);
    }
}

/*---------------Cookie Function-------------------*/
function setCookie(name, value, time='',path='') {
    if(time && path){
        var strsec = time * 1000;
        var exp = new Date();
        exp.setTime(exp.getTime() + strsec * 1);
        document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString() + ";path="+path;
    }else if(time){
        var strsec = time * 1000;
        var exp = new Date();
        exp.setTime(exp.getTime() + strsec * 1);
        document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString();
    }else if(path){
        document.cookie = name + "=" + escape(value) + ";path="+path;
    }else{
        document.cookie = name + "=" + escape(value);
    }
}

/**
 * 获取指定名称的cookie值。
 *
 * @param {string} c_name 需要获取值的cookie的名称。
 * @return {string} 如果找到指定名称的cookie，则返回其值；否则返回空字符串。
 */
function getCookie(c_name)
{
    // 检查是否有cookie存在
    if(document.cookie.length > 0) {
        // 寻找指定名称cookie的起始位置
        let c_start = document.cookie.indexOf(c_name + "=");
        // 如果找到了cookie的起始位置
        if(c_start != -1) {
            // 计算cookie值的起始位置
            c_start = c_start + c_name.length + 1;
            // 寻找cookie值的结束位置，即下一个分号的位置
            let c_end = document.cookie.indexOf(";", c_start);
            // 如果没有分号，则cookie值结束于文档末尾
            if(c_end == -1) c_end = document.cookie.length;
            // 解码并返回cookie的值
            return decodeURI(document.cookie.substring(c_start, c_end));
        }
    }

    // 如果没有找到指定名称的cookie，返回空字符串
    return "";
}


/**
 * 检查指定的cookie是否存在并返回布尔值。
 *
 * @param {string} c_name 需要检查的cookie的名称。
 * @returns {boolean} 如果cookie存在且不为空，则返回true；否则返回false。
 */
export function checkCookie(c_name) {
    // 通过getCookie函数获取指定名称的cookie值
    let username = getCookie(c_name);
    console.log(username);

    // 检查获取的cookie值是否为空或null，如果不为空则返回true，否则返回false
    if (username != null && username != "")
    { return true; }
    else
    { return false;  }
}

/**
 * 清除指定名称的cookie。
 *
 * 通过设置指定名称的cookie的值为空字符串，并将过期时间设置为过去的时间，来实现清除cookie的效果。
 * 这样做的原因是，大多数浏览器在遇到过期的cookie时会将其从存储中删除。
 *
 * @param name 要清除的cookie的名称。
 */
function clearCookie(name) {
    setCookie(name, "", -1);
}


/*--------Studio WX Message-------*/
/**
 * 检查用户代理是否包含“QiDi-Slicer”字符串。
 *
 * 该函数通过匹配用户代理字符串来判断当前访问是否来自QiDi-Slicer。（防跨站攻击判断来源）
 * 这对于在对接软件或工具时进行特定的兼容性处理或功能开启非常有用。
 *
 * @returns {boolean} 如果用户代理包含“QiDi-Slicer”则返回true，否则返回false。
 */
export function IsInSlicer()
{
    // 使用正则表达式匹配用户代理中是否包含"QiDi-Slicer"
    // 对接软件的时候需要用户代理中有指定字符用于正则匹配  BBL-Slicer


    let bMatch = navigator.userAgent.match(RegExp('QIDI-Slicer|QDT-Slicer', 'i'));
    // 用拓竹的做测试通过 能区分软件中和浏览器中
    // let bMatch=navigator.userAgent.match(  RegExp('BBL-Slicer','i') );
    if (bMatch){
        return true
    }else{
        return false
    }
}



/**
 * 发送wx消息。
 * @param {string} strMsg - 要发送的消息内容。
 */
export function SendWXMessage( strMsg )
{
    // 检查来源(我们暂时不检查来源)
    // let bCheck=IsInSlicer();
    //
    // // 如果检查结果不为空，则发送消息
    // if(bCheck!=null)
    // {
    //     window.wx.postMessage(strMsg);
    //     console.warn('发送token', strMsg)
    // }
    if (window.wx) {
        console.warn('window.wx 对象存在，准备发送消息。');
    } else {
        console.error('window.wx 对象不存在，无法发送消息。');// 可以选择在这里处理未找到 wx 对象的情况，例如记录日志或者抛出错误
        return
    }
    window.wx.postMessage(strMsg);
    console.warn('向软件发送token', strMsg);
}




function HandleStudio( pVal )
{
    let strCmd = pVal['command'];

    if(strCmd=='studio_userlogin')
    {
        SetLoginInfo(pVal['data']['avatar'],pVal['data']['name']);
    }
    else if(strCmd=='studio_useroffline')
    {
        SetUserOffline();
    }
}



export function  OnClickOpenProject(){
    // window.open("http://www.qidiwebtest.mzh2024.asia//homepage/index.html");
    // window.open("http://www.qidilogin.mzh2024.asia/#/account/login");
    var tSend={};
    tSend['sequence_id']=Math.round(new Date() / 1000);
    tSend['command']="homepage_openproject";

    SendWXMessage( JSON.stringify(tSend) );
    // alert(tSend)
}


/**
 * 获取登录信息，返回得到token
 * @constructor
 */
export function  OnClickGetLoginInfo(token){
    // window.open("http://www.qidiwebtest.mzh2024.asia//homepage/index.html");
    // window.open("http://www.qidilogin.mzh2024.asia/#/account/login");
    var tSend={};
    tSend['sequence_id']=Math.round(new Date() / 1000);
    tSend['command']="qidi_getToken";
    // tSend['command']="homepage_openproject"; //测试是否能正常和软件通信 打开选择文件的弹窗
    tSend['data']={};
    tSend['data']['token']=token;

    SendWXMessage( JSON.stringify(tSend) );
    // alert(JSON.stringify(tSend))
}


//发送打开用户协议的请求
export function  openUserAgreement(){
    var tSend={};
    tSend['sequence_id']=Math.round(new Date() / 1000);
    tSend['command']="homepage_openUserAgreement";
    tSend['data']={};
    tSend['data']['url']="/policies/terms";
    SendWXMessage(JSON.stringify(tSend) );
    // alert(JSON.stringify(tSend));
}
//发送打开隐私政策的请求
export function  openPrivacyPolicy(){
    var tSend={};
    tSend['sequence_id']=Math.round(new Date() / 1000);
    tSend['command']="homepage_openPrivacyPolicy";
    tSend['data']={};
    tSend['data']['url']="/policies/privacy";
    SendWXMessage(JSON.stringify(tSend) );
    // alert(JSON.stringify(tSend));
}



// WEBPACK FOOTER //
// ./src/utils/studioWXMessage.js